import { Action } from '@ngrx/store';
import { User } from '../../models/user';
import { LoginResponse } from '../auth.models';

export enum AuthActionTypes {
	Load = '[Auth] Load',
	LoadOk = '[Auth] Load Ok',
	LoadFail = '[Auth] Load Fail',

	Login = '[Auth] Login',
	LoginCallback = '[Auth] Login Callback',
	LoginOk = '[Auth] Login Ok',
	LoginFail = '[Auth] Login Fail',
	TokenRefreshed = '[Auth] Token Refreshed',

	Logout = '[Auth] Logout',
	SignedOut = '[Auth] Signed Out',
	AnonymousSessionOk = '[Auth] Anonymous Session Ok',
	AnonymousSessionFail = '[Auth] Anonymous Session Fail',
	AnonymousSessionEnded = '[Auth] Anonymous Session Ended',

	LoadStorage = '[Auth] Load Storage',
	LoadStorageOk = '[Auth] Load Storage Ok',
	LoadStorageFail = '[Auth] Load Storage Fail',

	RefreshProfile = '[Auth] Refresh Profile',
	RefreshProfileOk = '[Auth] Refresh Profile Ok',
	RefreshProfileFail = '[Auth] Refresh Profile Fail',

	UpdateCoordinates = '[Auth] Update Coordinates',
	UpdateCoordinatesOk = '[Auth] Update Coordinates Ok',
	UpdateCoordinatesFail = '[Auth] Update Coordinates Fail'
}

export class LoadAction implements Action {
  readonly type = AuthActionTypes.Load;
  constructor() {

  }
}

export class LoadOkAction implements Action {
  readonly type = AuthActionTypes.LoadOk;
  constructor(public response: User) {

  }
}

export class LoadFailAction implements Action {
  readonly type = AuthActionTypes.LoadFail;
  constructor(public error?: any) {

  }
}

// ID-5: sends the user to Pro Pool ID's login - or, with `register`, straight to its registration (ID-6B), which
// signs the new account in and comes back the same way. LoginCallback brings the answer back.
export class LoginAction implements Action {
  readonly type = AuthActionTypes.Login;
  constructor(public register = false) {

  }
}

export class LoginCallbackAction implements Action {
  readonly type = AuthActionTypes.LoginCallback;
  constructor(public url: string) {

  }
}

export class LoginOkAction implements Action {
  readonly type = AuthActionTypes.LoginOk;
  constructor(public response: LoginResponse) {

  }
}

export class LoginFailAction implements Action {
  readonly type = AuthActionTypes.LoginFail;
  constructor(public error?: any) {

  }
}

export class TokenRefreshedAction implements Action {
  readonly type = AuthActionTypes.TokenRefreshed;
  constructor(public response: LoginResponse) {

  }
}

export class LogoutAction implements Action {
  readonly type = AuthActionTypes.Logout;
}

// No session (anymore): nothing stored, the token was rejected, the refresh token is spent, or the user logged out.
// The app then starts a new app-local anonymous user (ID-8).
export class SignedOutAction implements Action {
  readonly type = AuthActionTypes.SignedOut;
}

export class AnonymousSessionOkAction implements Action {
  readonly type = AuthActionTypes.AnonymousSessionOk;
  constructor(public anonymousToken: string) {

  }
}

export class AnonymousSessionFailAction implements Action {
  readonly type = AuthActionTypes.AnonymousSessionFail;
  constructor(public error?: any) {

  }
}

// After a Pro Pool ID login the anonymous session is done: linked to the account, or left behind for an existing one.
export class AnonymousSessionEndedAction implements Action {
  readonly type = AuthActionTypes.AnonymousSessionEnded;
}

export class LoadStorageAction implements Action {
	readonly type = AuthActionTypes.LoadStorage;
	constructor() {

	}
}

export class LoadStorageOkAction implements Action {
	readonly type = AuthActionTypes.LoadStorageOk;
	constructor(public store: any) {

	}
}

export class LoadStorageFailAction implements Action {
	readonly type = AuthActionTypes.LoadStorageFail;
	constructor(public error?: any) {

	}
}

// ID-10: the profile is edited at Pro Pool ID, so the app asks for the result instead of knowing it.
export class RefreshProfileAction implements Action {
	readonly type = AuthActionTypes.RefreshProfile;
}

export class RefreshProfileOkAction implements Action {
	readonly type = AuthActionTypes.RefreshProfileOk;
	constructor(public response: User) {

	}
}

export class RefreshProfileFailAction implements Action {
	readonly type = AuthActionTypes.RefreshProfileFail;
	constructor(public error?: any) {

	}
}

export class UpdateCoordinatesAction implements Action {
	readonly type = AuthActionTypes.UpdateCoordinates;

	constructor() {

	}
}

export class UpdateCoordinatesOkAction implements Action {
	readonly type = AuthActionTypes.UpdateCoordinatesOk;
	constructor(public latitude, public longitude) {

	}
}

export class UpdateCoordinatesFailAction implements Action {
	readonly type = AuthActionTypes.UpdateCoordinatesFail;
	constructor(public error?: any) {

	}
}

export type AuthActions =
	LoadAction |
	LoadOkAction |
	LoadFailAction |
	LoginAction |
	LoginCallbackAction |
	LoginOkAction |
	LoginFailAction |
	TokenRefreshedAction |
	LogoutAction |
	SignedOutAction |
	AnonymousSessionOkAction |
	AnonymousSessionFailAction |
	AnonymousSessionEndedAction |
	LoadStorageAction |
	LoadStorageOkAction |
	LoadStorageFailAction |
	RefreshProfileAction |
	RefreshProfileOkAction |
	RefreshProfileFailAction |
	UpdateCoordinatesAction |
	UpdateCoordinatesOkAction |
	UpdateCoordinatesFailAction;
